<template>
    <div class="shares_page">
        <div class="search_group">
            <div class="search_label">対象期間</div>
            <div class="search_form">
                <div class="search_item">
                    <el-date-picker v-model="start" type="date" @change="changeDate"/>
                </div>
                <span>~</span>
                <div class="search_item">
                    <el-date-picker v-model="end" type="date" @change="changeDate"/>
                </div>
            </div>
        </div>
        <div class="items_list white">
            <div v-for="group in groups">
                <div class="item">
                    <strong class="text">{{group.display_name}}</strong>
                </div>
                <div class="item" v-for="institution in group.institutions"
                     @click="handleClickInstitution(institution.institution_code)">
                    <span class="text">{{institution.official_name_kanji}}</span>
                    <span class="badge" v-if="institution.total_unread_messages > 0">
                        {{institution.total_unread_messages > 9 ? '9+' :institution.total_unread_messages}}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import {mapActions} from 'vuex'
  import InstitutionApi from '@/api/institution'
  import moment from 'moment'
  import _ from 'lodash'

  export default {
    data () {
      return {
        groups: [],
        start: moment().subtract(7, 'days'),
        end: moment()
      }
    },
    methods: {
      ...mapActions({
        setNavigatorLinks: 'navigator/setLinks',
        setNavigatorTitle: 'navigator/setTitle'
      }),
      handleClickInstitution (institutionCode) {
        this.$router.push({name: 'shares.show', params: {institutionCode: institutionCode}})
      },
      changeDate () {
        this.getInstitutionFavorite()
      },
      async getInstitutionFavorite () {
        const loading = this.$loading.show()
        try {
          const start = moment(this.start).format('Y-MM-DD 00:00:00')
          const end = moment(this.end).format('Y-MM-DD 23:59:59')
          const res = await InstitutionApi.getFavorites({start, end})
          let groups = res.data.data
          let temp = null
          let index = _.findIndex(groups, n => n.employee_code === this.$auth.user().employee_code)
          if (index !== -1) {
            temp = groups[index]
            groups.splice(index, 1)
            this.groups = [temp, ...groups]
          } else {
            this.groups = res.data.data
          }
        } catch (e) {
          console.log(e)
        }
        loading.hide()
      }
    },
    mounted () {
      this.getInstitutionFavorite()
      this.setNavigatorLinks([])
      this.setNavigatorTitle('シェア')
    }
  }
</script>



// WEBPACK FOOTER //
// src/screens/shares/index.vue